import { SWEEPSTAKES_LANGUAGES } from 'src/services/i18n/utils/languageVariants'
import { getCurrencySymbol } from 'src/utils/getCurrencySymbol'

// Social bet amounts are still wired as USD (see realtime social_event mapper:
// amount_usd / potential_payout_usd) and converted for DISPLAY via
// getSocialUsdRate. The symbol must follow that one conversion decision: the
// viewer's own symbol only when getSocialUsdRate reported `converted: true`
// (server usdRate or its sweeps fallback table), `$` otherwise — extend both
// together.
export const getSocialCurrencySymbol = (
  language: string,
  currency: string | undefined,
  converted: boolean
): string | null => {
  if (SWEEPSTAKES_LANGUAGES.includes(language)) {
    return null
  }
  // The viewer's own currency — but ONLY when the amounts actually converted
  // (server usdRate or the sweeps table; the `converted` flag from
  // getSocialUsdRate). When no conversion applies (crypto phase 1, unknown
  // currency, rate lookup failure) the values on screen are USD, so the
  // symbol MUST stay '$': a viewer-currency symbol over USD numbers is the
  // mislabel bug class this feature exists to remove.
  //
  // getCurrencySymbol is try/caught internally and degrades to '$' for a
  // currency missing from @repo/money config.json, so an unlisted operator
  // coin cannot throw here.
  if (!converted) {
    return getCurrencySymbol('USD')
  }
  return getCurrencySymbol(currency ?? 'USD')
}

/**
 * Build a symbol-prefixed amount STRING. The resolver above returns null BY
 * DESIGN for excluded languages (en-soc — sweepstakes hide the symbol); JSX
 * sites drop null silently, but a template literal stringifies it — a sweeps
 * operator's feed rendered won amounts as "null1,400.00" (client report
 * 2026-08-17). Any string-built amount must come through here.
 */
export const formatSocialAmount = (symbol: string | null, formatted: string): string =>
  `${symbol ?? ''}${formatted}`
